import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';

import {
  MENTEE_MODULE_STATUSES,
  setDeleteMenteeModuleModalState,
  setSelectedMenteeModule,
} from 'features/moduleManagement';

function DeleteMenteeModuleButton({ menteeModule }) {
  const dispatch = useDispatch();

  const handleOnDelete = useCallback(() => {
    batch(() => {
      dispatch(setDeleteMenteeModuleModalState(true));
      dispatch(
        setSelectedMenteeModule({
          ...menteeModule,
          updatedStatus: MENTEE_MODULE_STATUSES.deprecated,
        })
      );
    });
  }, [dispatch, menteeModule]);

  return (
    <Tappable
      className="danger"
      onClick={handleOnDelete}
    >
      <Icon name="trash" />
    </Tappable>
  );
}

export default DeleteMenteeModuleButton;
